/* =============================================================================
 * toDateInputValue — coerce a date value to what <input type="date"> requires.
 * -----------------------------------------------------------------------------
 * Postgres `date` columns come back as full ISO timestamps (e.g.
 * "2026-05-01T00:00:00.000Z"); a native date input rejects anything with a time
 * component and renders BLANK — the silent date-wipe on edit (plan 0.3 / BUG #253).
 * Slicing to YYYY-MM-DD (never `new Date(...)`, which would UTC-shift the day) is
 * the tz-safe fix. Shared so every date modal loads dates the same way.
 * ========================================================================== */
export function toDateInputValue(v: string | null | undefined): string {
  if (!v) return '';
  return String(v).split('T')[0];
}
